import { render, staticRenderFns } from "./PropertyPdfList.vue?vue&type=template&id=2533fc2a&scoped=true&"
import script from "./PropertyPdfList.vue?vue&type=script&lang=js&"
export * from "./PropertyPdfList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2533fc2a",
  null
  
)

export default component.exports